import {Column} from 'react-table'
import {Model} from '@/_metronic/helpers'
import {
  TextCell,
  MoneyCell,
  BooleanCell,
  ActionsCell,
  CustomHeader
} from '@/components/table/columns'

import {TypeCell} from './TypeCell'

const Columns: ReadonlyArray<Column<Model>> = [{
  Header: (props) => <CustomHeader tableProps={props} title='Name' className='min-w-70px sortable' />,
  id: 'label',
  Cell: ({...props}) => (
    <TypeCell
      label={props.data[props.row.index].label}
      type={props.data[props.row.index].type}
      country={props.data[props.row.index].country}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Enabled' className='min-w-70px text-center' />,
  id: 'offers.enabled',
  Cell: ({...props}) => (
    <BooleanCell
      value={props.data[props.row.index].enabled && props.data[props.row.index].offer.enabled}
      type='icon'
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Amount' className='min-w-70px sortable' />,
  id: 'offers.amount',
  Cell: ({...props}) => (
    <MoneyCell
      amount={props.data[props.row.index].offer.amount}
      currency={props.data[props.row.index].offer.currency}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Payout' className='min-w-70px sortable' />,
  id: 'offers.payout',
  Cell: ({...props}) => (
    <MoneyCell
      amount={props.data[props.row.index].offer.payout}
      currency={props.data[props.row.index].offer.currency}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='Credits' className='min-w-70px sortable' />,
  id: 'offers.credits',
  Cell: ({...props}) => (
    <TextCell
      content={props.data[props.row.index].offer.credits}
    />
  )
}, {
  Header: (props) => <CustomHeader tableProps={props} title='rate' className='min-w-70px' />,
  id: 'offers.rate',
  Cell: ({...props}) => (
    <TextCell
      content={(props.data[props.row.index].offer.credits / props.data[props.row.index].offer.payout).toFixed(2)}
    />
  )

}, {
  Header: (props) => <CustomHeader tableProps={props} title='Discrete' className='min-w-70px text-center' />,
  id: 'offers.discrete',
  Cell: ({...props}) => (
    <BooleanCell
      value={props.data[props.row.index].enabled && props.data[props.row.index].offer.discrete}
      type='icon'
    />
  )

}, {
  Header: (props) => (
    <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
  ),
  id: 'actions',
  Cell: ({...props}) => (
    <ActionsCell
      itemForUpdate={props.data[props.row.index]}
      actions={[{
        icon: 'pencil',
        label: 'P2C.PAIMENT.PRICING.LIST.BTN_EDIT',
        openModal: 'edit'
      }]}
    />
  )
}]

export {Columns}
